import { createContext, PropsWithChildren } from "react";
import { CaseAction } from "interfaces/case-action";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { isNil } from "lodash";

export const CaseActionsContext = createContext<{
  loading: boolean;
  error: boolean;
  actions: CaseAction[];
  refetchActions(): Promise<void>;
}>({
  loading: false,
  error: false,
  actions: [],
  refetchActions: async () => {}
});
CaseActionsContext.displayName = "CaseActionsContext";

export const CaseActionsProvider = ({
  caseId,
  children
}: PropsWithChildren<{ caseId: number }>): JSX.Element => {
  const { loading, error, response = { results: [] }, refetch } = useFetchGetV2(
    `case_actions?case_id__in=${caseId}`,
    isNil(caseId)
  );

  return (
    <CaseActionsContext.Provider
      value={{
        loading,
        error,
        actions: response.results,
        refetchActions: async () => refetch()
      }}
    >
      {children}
    </CaseActionsContext.Provider>
  );
};
